import { parseInt } from "lodash";


// formats "2021-11-08T18:15:00.000Z" to "8/18/2021"
const isoToLocaleFormat = (serverDateTime) => {
  const parsedDate = Date.parse(serverDateTime)
  return new Date(parsedDate).toLocaleDateString()
}

const isoToLocaleDateTimeFormat = (serverDateTime) => {
  const parsedDate = Date.parse(serverDateTime)
  return new Date(parsedDate).toLocaleString()
}

// formats "Tue Nov 09 2021 00:00:00 GMT+0545 (Nepal Time) to "2021-11-08T18:15:00.000Z"
const utcToIsoFormat = (readableDateTime) => {
  const parsedDate = Date.parse(readableDateTime)
  return new Date(parsedDate).toISOString()
}

// output is {hr:5, min:45} for Nepal Time
const getLocalTimeOffset = (date) => {
  const localeTimeString = date.toLocaleTimeString()
  const hrMin = localeTimeString.split(":")
  return { hr: parseInt(hrMin[0]), min: parseInt(hrMin[1]) }
}

const startDateToIsoFormat = (readableDate) => {
  const parsedDate = new Date(readableDate)
  const { hr, min } = getLocalTimeOffset(parsedDate)
  const localDateTime = parsedDate.setHours(hr + hr, min + min)
  return new Date(localDateTime).toISOString()
}

const isoFormatToStartDate = (utcDateTime) => {
  return new Date(utcDateTime).toLocaleDateString('en', { timeZone: 'UTC' })
}


const endDateToIsoFormat = (readableDate) => {
  const parsedDate = new Date(readableDate)
  const { hr, min } = getLocalTimeOffset(parsedDate)
  const localDateTime = parsedDate.setHours(23 + hr, 59 + min)
  return new Date(localDateTime).toISOString()
}

const isoFormatToEndDate = (utcDateTime) => {
  return new Date(utcDateTime).toLocaleDateString('en', { timeZone: 'UTC' })
}

const getTimeIn12HrFormat = (time) => {
  return new Date('2020-01-01T' + time + 'Z')
    .toLocaleTimeString('en-US', { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' })
}

const isoFormatToLocalTimeString = (isoDateTime, format12Hr = true) => {
  return new Date(isoDateTime).toLocaleTimeString('en-NP', { hour: 'numeric', minute: 'numeric', hour12: format12Hr });
}

const timeToUTCTimeString = (time) => {
  const dateTime = new Date(Date.parse(`01/01/2022 ${time}`));
  return `${dateTime.getUTCHours() < 10 ? "0" : ''}${dateTime.getUTCHours()}:${dateTime.getUTCMinutes() < 10 ? "0" : ''}${dateTime.getUTCMinutes()}`;
}

const utcToLocalTimeString = (utcTime, format12Hr = true) => {
  return new Date(Date.parse(`01/01/2022 ${utcTime} UTC`)).toLocaleTimeString('en', { timeStyle: 'short', hour12: format12Hr });
}

const utcDateTimeToLocalString = (utcTime, format12Hr = true, timeOnly = true) => {
  const utcDate = new Date(`${utcTime}Z`);
  const options = {
    hour12: format12Hr,
    ...(timeOnly && { hour: 'numeric' }),
    ...(timeOnly && { minute: 'numeric' })
  };
  return utcDate.toLocaleString('en-US', options);
}

const localDateStringToIsoString = (localDate) => {
  const date = localDate ? new Date(localDate) : new Date();
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, -8);
}

const utcToLocalDateTimeFormat = (utc) => {
  var utcDate = new Date(utc);

  // Get the timezone offset in minutes
  var timezoneOffsetMinutes = utcDate.getTimezoneOffset();

  // Convert the offset to milliseconds
  var timezoneOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;

  // Adjust the UTC time to local time
  var localTimeMilliseconds = utcDate.getTime() - timezoneOffsetMilliseconds;

  // Create a new Date object with the local time
  var localDate = new Date(localTimeMilliseconds);

  // Get the year, month, day, hour, and minute parts
  var localYear = localDate.getFullYear();
  var localMonth = ('0' + (localDate.getMonth() + 1)).slice(-2);
  var localDay = ('0' + localDate.getDate()).slice(-2);
  var localHours = ('0' + localDate.getHours()).slice(-2);
  var localMinutes = ('0' + localDate.getMinutes()).slice(-2);

  // Format the local time as "yyyy-MM-ddThh:mm"
  var localTimeString = localYear + '-' + localMonth + '-' + localDay + 'T' + localHours + ':' + localMinutes;

  return localTimeString
}


export {
  localDateStringToIsoString,
  utcDateTimeToLocalString,
  isoToLocaleFormat,
  utcToIsoFormat,
  startDateToIsoFormat,
  isoFormatToStartDate,
  endDateToIsoFormat,
  isoFormatToEndDate,
  getTimeIn12HrFormat,
  isoFormatToLocalTimeString,
  timeToUTCTimeString,
  utcToLocalTimeString,
  isoToLocaleDateTimeFormat,
  utcToLocalDateTimeFormat
}
